import React from "react";
import { Admin, CustomRoutes, List } from "react-admin";
import { Route } from "react-router-dom";
import { MyLayout } from "../../components/Layout/Layout";
import { ThemeProvider } from "@material-ui/core/styles";
import Theme from "../../components/Theme/Theme";
import "../../components/Layout/layout.css";
import { AuthProvider } from "../../context/AuthContext";
import PermissionRoute from "./PermissionRoute";
import Calendar from "../Calendar/calendar";
import Dashboard from "../Dashboard/dashboard";
import Management from "../Management/management";
import MyShifts from "../MyShifts/myShifts";
import MyTeam from "../MyTeam/myTeam";
import AcceptShifts from "../AcceptedShifts/acceptedShifts";
import CallBack from "../CallBacks/callBacks";
import FillShift from "../FillShift/fillShift";
import Details from "../Details/details";
import Messaging from "../Messaging/messaging";
import ApproveShifts from "../ApproveShifts/approveShifts";
import Members from "../Members/members";
import UserSetting from "../UserSettings/userSettings";
import System from "../System/system";
import AdminPanel from "../System/adminPanel";
import AuditLog from "../System/auditLog";
import AuditLogSetting from "../System/auditLogSetting";
import ConfigSystem from "../System/configSystem";
import SelectOption from "../System/selectOption";
import GroupSettings from "../System/GroupSetting";
import Employee from "../Members/Employee";
import EmployeeLog from "../Members/employeeLog";
import RunCard from "../../components/RunCard/RunCard";
import AddLocation from "../Inventory/AddLocation";
import AddItem from "../Inventory/AddItem";
import FireDepartment from "../Inventory/FireDepartment";
import Inventory from "../Inventory/Inventory";
import RTO from "../RTO/RTO";
import ItemList from "../Items/ItemList";
import ItemDetail from "../Items/ItemDetail";
import ShiftWork from "../FillShift/ShiftWork";
import Lists from "../Lists/Lists";
import InventoryNew from "../InventoryNew/InventoryNew";
import OvertimeSignup from "../OvertimeSignup/OvertimeSignup";
import Certificates from "../Certificates/Certificates";
import AllCertificates from "../Certificates/AllCertificates";
import CertificateMembers from "../Certificates/CertificateMembers";
import Payroll from "../Payroll/Payroll";
import AddPayroll from "../Payroll/AddPayroll";
import ManagePayroll from "../Payroll/ManagePayroll";
import Incidents from "../Incidents/Incidents";
import IncidentsPage from "../Incidents/";
import Overview from "../Overview/Overview";
import Performance from "../Performance/Performance";
import MapPage from "../Map/Map";
import Reports from "../Reports/Reports";
import AdjustHours from "../AdjustHours/adjustHours";
import Checklist from "../Checklist/Checklist";
import AddChecklist from "../Checklist/AddChecklist";
import ChecklistSchedule from "../Checklist/ChecklistSchedule";
import ChecklistDetails from "../Checklist/ChecklistDetails.jsx";
import EditChecklist from "../Checklist/EditChecklist";
import MyChecklist from "../MyChecklist/MyChecklist";
import MyChecklistItems from "../MyChecklist/MyChecklistItems";
import ResourceAssignment from "../ResourceAssignment/ResourceAssignment";
import ScheduleOverride from "../ResourceAssignment/ScheduleOverride";
import ManageOvertime from "../ManageOvertime/ManageOvertime";
import Ticketing from "../Ticketing/Ticketing";
import ImportHistory from "../ImportHistory.jsx";
import UserMessages from "../Messaging/userMessages.jsx";
import ReportDetails from "../Reports/ReportDetails.jsx";
import SummaryData from "../Reports/SummaryData.jsx";
import PtoBalances from "../Reports/PtoBalances.jsx";
import SuggestionBox from "../InventoryNew/SuggestionBox.jsx"
import Notifications from "../Notifications/notifications.jsx";
import SwapReport from "../Reports/SwapReport.jsx";
import ShiftAllocationReport from "../Reports/ShiftAllocationReport.jsx"
import ChecklistEditItems from "../Checklist/ChecklistEditItems.jsx";
import Availability from "../Availability/Availability.jsx";
import ShiftCalls from "../ShiftCalls/ShiftCalls.jsx";
import MyShiftCalls from "../ShiftCalls/MyShiftCalls.jsx";
import PositionAssignment from "../PositionAssignment/PositionAssignment";
import CancelledAssignments from "../PositionAssignment/CancelledAssignments.jsx"
import ViewBids from "../ViewBids/ViewBids.jsx"
import ChangePassword from '../UserSettings/changePassword.jsx'
import WatchParty from "../WatchParty/watchParty.jsx";
import ChecklistData from "../Checklist/ChecklistData.jsx";
import Swaplist from "../ApproveShifts/Swaplist.jsx";
import AttributeManagement from "../AttributeManagement/AttributeManagement.jsx";
import EntityManagement from "../AttributeManagement/EntityManagement.jsx";
import PersonalPayrollReport from "../UserSettings/PersonalPayrollReport.jsx";
import PersonalPayroll from "../Payroll/PersonalPayroll.jsx";
import PrePlansAndInspections from "../PrePlansAndInspections/index.jsx";
import VolunteerSignup from "../OvertimeSignup/VolunteerSignup.jsx";
import ReportPayrollScreen  from '../Reports/ReportPayroll/ReportPayrollScreen';
import ReportPayrollSummaryScreen from '../Reports/ReportPayrollSummary/ReportPayrollSummaryScreen';
import ReportOvertimeListMaster from '../Reports/ReportOvertimeListMaster/ReportOvertimeListMaster';
import MunisExportReport from '../Reports/MunisExportReport';
import SwapShiftsReport from '../Reports/SwapShiftsReport';
import WeeklyPayrollReport from '../Reports/WeeklyPayrollReport/WeeklyPayrollReport';
import AdjustHoursReport from '../Reports/AdjustHoursReport/AdjustHoursReport';
import AvailabilityDetailReport from '../Reports/AvailabilityDetailReport/AvailabilityDetailReport';
import AvailabilitySummaryReport from '../Reports/AvailabilitySummaryReport/AvailabilitySummaryReport';
import ReportOvertimeScreen from '../Reports/ReportOvertime/ReportOvertimeScreen';
import MiltonReport from '../Reports/MiltonReport';
import CharltonReport from '../Reports/CharltonReport';
import ReportCallback from '../Reports/ReportCallback';
import ReportPtoScreen from '../Reports/ReportPto/ReportPtoScreen';
import WoburnMunisOvertimeReport from "../Reports/WoburnMunisOvertimeReport/index.jsx";
import WoburnMunisPtoReport from "../Reports/WoburnMunisPtoReport/index.jsx";
import WoburnPTOReport from "../Reports/WoburnPTOReport/index.jsx";
import WoburnReassignmentReport from "../Reports/WoburnReassignmentReport/WoburnReassignmentReport.jsx";
import WoburnOvertimeReport from "../Reports/WoburnOvertimeReport/index.jsx";
import WoburnReport from "../Reports/WoburnReport/index.jsx";
import NerisSettingsPage from "../NerisSettingsPage/index.jsx";
import NerisReportForm from "../NerisReportForm/index.jsx";
import { REPORTS_INFO } from "../../constants/Reports/index.js";
import ReportsPermissionRoute from "./ReportsPermissionRoute.jsx";
import PtoBalancesReport from "../Reports/PtoBalances/index.jsx";
import LeaveBook from "../LeaveBook/LeaveBook.jsx";
import { StationAndUnitsForm } from "../StationAndUnitsForm/index.jsx";
import FillPositions from "../FillShift/fillPositions.jsx";
import PositionWork from "../FillShift/PositionWork.jsx";
import NerisGroupAndTypes from '../NerisGroupAndTypes/NerisGroupAndTypes';
import VacationBids from "../VacationBids/VacationBids.jsx";
import VacationBidMembers from "../VacationBids/VacationBidsMembers.jsx";
import VacationBidsUser from "../VacationBids/VacationBidsUser.jsx";
export default function Home() {
  return (
    <ThemeProvider theme={Theme}>
      <AuthProvider>
        <Admin theme={Theme} layout={MyLayout} basename="/firehouse">
          <CustomRoutes>
            <Route path="/firehouse/calendar" element={<Calendar />} />
            <Route
              path="/firehouse/schedule"
              element={
                <PermissionRoute permissionName="all" pageName="SCHEDULE">
                  <Management />
                </PermissionRoute>
              }
            />
            <Route path="/firehouse/runcard" element={<RunCard />} />
            <Route path="/firehouse/my-shifts" element={<MyShifts />} />
            <Route path="/firehouse/my-team" element={<MyTeam />} />
            <Route path="/firehouse/my-team-today" element={<MyTeam working_today={true} />} />
            <Route path="/firehouse/accept-shifts" element={<AcceptShifts />} />
            <Route path="/firehouse/shift-calls" element={<ShiftCalls />} />
            <Route path="/firehouse/my-shift-calls" element={<MyShiftCalls />} />
            <Route
              path="/firehouse/callbacks"
              element={
                <PermissionRoute permissionName="CB_Auth">
                  <CallBack />
                </PermissionRoute>
              }
            />
            <Route
              path="/firehouse/fill-shift"
              element={
                <PermissionRoute permissionName="OT_Auth">
                  <FillShift />
                </PermissionRoute>
              }
            />
            <Route
              path="/firehouse/fill-shift-work/:batch_id/:job_id"
              element={
                <PermissionRoute permissionName="OT_Auth">
                  <ShiftWork />
                </PermissionRoute>
              }
            />
            <Route
              path="/firehouse/fill-positions"
              element={
                <PermissionRoute permissionName="OT_Auth">
                  <FillPositions />
                </PermissionRoute>
              }
            />
            <Route
              path="/firehouse/fill-position-work/:batch_id/:job_id"
              element={
                <PermissionRoute permissionName="OT_Auth">
                  <PositionWork />
                </PermissionRoute>
              }
            />
            <Route path="/firehouse/details" element={<Details />} />
            <Route path="/firehouse/messaging" element={<Messaging />} />
            <Route path="/firehouse/user-messages" element={<UserMessages />} />
            <Route
              path="/firehouse/approve-shifts"
              element={
                <PermissionRoute permissionName="OT_Auth,OT_APPROVE">
                  <ApproveShifts />
                </PermissionRoute>
              }
            />
            <Route path='/firehouse/change-password' element={<ChangePassword />} />
            <Route path="/firehouse/members" element={<Members />} />
            <Route path="/firehouse/employee" element={<Employee />} />
            <Route path="/firehouse/employeeLog/:empId" element={<EmployeeLog />} />
            <Route path="/firehouse/user-settings" element={<UserSetting />} />
            <Route path="/firehouse/personal-payroll-report" element={<PersonalPayrollReport />} />
            <Route path="/firehouse/personal-payroll-list" element={<PersonalPayroll />} />
            <Route path="/firehouse/view-log" element={<System />} />
            <Route path="/firehouse/admin-panel" element={<AdminPanel />} />
            <Route path="/firehouse/audit-log" element={<AuditLog />} />
            <Route path="/firehouse/audit-log-setting" element={<AuditLogSetting />} />
            <Route path="/firehouse/config" element={<ConfigSystem />} />
            <Route path="/firehouse/select-option" element={<SelectOption />} />
            <Route path="/firehouse/groups-settings" element={<GroupSettings />} />
            {/* <Route path="/firehouse/inventory" element={<Inventory />} /> */}
            <Route path="/firehouse/inventory" element={<InventoryNew />} />
            <Route path="/firehouse/inventory/location" element={<AddLocation />} />
            <Route path="/firehouse/inventory/item" element={<AddItem />} />
            <Route path="/firehouse/inventory/suggestions" element={<SuggestionBox />} />
            <Route path="/firehouse/inventory/fire" element={<FireDepartment />} />
            <Route path="/firehouse/RTO" element={<RTO />} />
            <Route path="/firehouse/Lists" element={<Lists />} />
            <Route path="/firehouse/items" element={<ItemList />} />
            <Route path="/firehouse/items/detail" element={<ItemDetail />} />
            <Route path="/firehouse/overtime-signup" element={<OvertimeSignup />} />
            <Route path="/firehouse/volunteer-signup" element={<VolunteerSignup />} />
            <Route path="/firehouse/certificates" element={<Certificates />} />
            <Route path="/firehouse/certificates/all" element={<AllCertificates />} />
            <Route path="/firehouse/certificate-members/:id" element={<CertificateMembers />} />
            <Route path="/firehouse/payroll" element={<Payroll />} />
            <Route path="/firehouse/add-payroll" element={<AddPayroll />} />
            <Route path="/firehouse/manage-payroll" element={<ManagePayroll />} />
            <Route path="/firehouse/checklist" element={<Checklist />} />
            <Route path="/firehouse/checklist-chief/data" element={<ChecklistData />} />
            <Route path="/firehouse/checklist-add" element={<AddChecklist />} />
            <Route path="/firehouse/checklist-schedule/:id" element={<ChecklistSchedule />} />
            <Route path="/firehouse/checklist-details/:id/:scheduleId" element={<ChecklistDetails />} />
            <Route path="/firehouse/edit-checklist/:id" element={<EditChecklist />} />
            <Route path="/firehouse/edit-checklist-items/:id" element={<ChecklistEditItems />} />
            <Route path="/firehouse/my-checklist" element={<MyChecklist />} />
            <Route path="/firehouse/mychecklist-item/:id/:scheduleId" element={<MyChecklistItems />} />
            <Route path="/firehouse/resource-assignment" element={<ResourceAssignment />} />
            <Route path="/firehouse/position-assignment" element={<PositionAssignment />} />
            <Route path="/firehouse/cancelled-assignments" element={<CancelledAssignments />} />
            <Route path="/firehouse/schedule-override" element={<ScheduleOverride />} />
            <Route path="/firehouse/manage-overtime" element={<ManageOvertime />} />
            <Route path="/firehouse/daily-swap-list" element={<Swaplist />} />
            <Route path="/firehouse/reports" element={<Reports />} />
            <Route path="/firehouse/view-bids" element={<ViewBids />} />
            <Route path="/firehouse/availability" element={<Availability />} />
            <Route path="/firehouse/notifications" element={<Notifications />} />
            <Route path="/firehouse/reports/swap" element={<SwapReport />} />
						<Route path="/firehouse/attribute-management" element={<AttributeManagement />}/>
						<Route path="/firehouse/entity-management" element={<EntityManagement />}/>
            <Route path='/firehouse/incidents' element={<IncidentsPage />}/>
            <Route path='/firehouse/leave-book' element={<LeaveBook />}>
            <Route path="/firehouse/vacation-bids" element={<VacationBids />} />
            <Route path="/firehouse/vacation-bid-members/:id" element={<VacationBidMembers />} />
            <Route path="/firehouse/vacation-bid-user" element={<VacationBidsUser />} />
              <Route index element={<Incidents />} />
              <Route path='overview' element={<Overview />} />
              <Route path='performance' element={<Performance />} />
              <Route path='map' element={<MapPage />} />
            </Route>
            <Route
              path="/firehouse/adjust-hours"
              element={
                <PermissionRoute permissionName="Emp_Auth,OT_Auth">
                  <AdjustHours />
                </PermissionRoute>
              }
            />
            <Route path={REPORTS_INFO.ADJUST_HOURS.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.ADJUST_HOURS.id}>
                <AdjustHoursReport />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.AVAILABILITY_DETAILT.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.AVAILABILITY_DETAILT.id}>
                <AvailabilityDetailReport />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.AVAILABILITY_SUMMARY.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.AVAILABILITY_SUMMARY.id}>
                <AvailabilitySummaryReport />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.CALLBACK.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.CALLBACK.id}>
                <ReportCallback />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.HOLIDAY.link} element={
                <ReportsPermissionRoute reportId={REPORTS_INFO.HOLIDAY.id}>
                  <CharltonReport />
                </ReportsPermissionRoute>
              }
            />
            <Route path={REPORTS_INFO.MILTON.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.MILTON.id}>
                <MiltonReport />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.MUNIS.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.MUNIS.id}>
                <MunisExportReport />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.OVERTIME.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.OVERTIME.id}>
                <ReportOvertimeScreen />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.OVERTIME_LIST_MASTER.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.OVERTIME_LIST_MASTER.id}>
                <ReportOvertimeListMaster />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.PAYROLL.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.PAYROLL.id}>
                <ReportPayrollScreen />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.PAYROLL_SUMMARY.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.PAYROLL_SUMMARY.id}>
                <ReportPayrollSummaryScreen />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.PTO.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.PTO.id}>
                <ReportPtoScreen />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.SHIFT_SWAPS.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.SHIFT_SWAPS.id}>
                <SwapShiftsReport />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.WEEKLY_PAYROLL.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.WEEKLY_PAYROLL.id}>
                <WeeklyPayrollReport />
              </ReportsPermissionRoute>
            }
            />
             {/* Dev version We need to use this one on dev and staging, we dont need it on prod for now */}
            <Route path={REPORTS_INFO.PTO_BALANCES.link} element={
              <ReportsPermissionRoute reportId={REPORTS_INFO.PTO_BALANCES.id}>
                <PtoBalancesReport />
              </ReportsPermissionRoute>
            }
            />
            <Route path={REPORTS_INFO.WOBURN_PAYBACK.link} element={
                <ReportsPermissionRoute reportId={REPORTS_INFO.WOBURN_PAYBACK.id}>
                  <WoburnReport />
                </ReportsPermissionRoute>
              }
            />
            <Route path={REPORTS_INFO.WOBURN_OVERTIME.link} element={
                <ReportsPermissionRoute reportId={REPORTS_INFO.WOBURN_OVERTIME.id}>
                  <WoburnOvertimeReport />
                </ReportsPermissionRoute>
              }
            />
            <Route path={REPORTS_INFO.WOBURN_REASSIGNMENT.link} element={
                <ReportsPermissionRoute reportId={REPORTS_INFO.WOBURN_REASSIGNMENT.id}>
                  <WoburnReassignmentReport />
                </ReportsPermissionRoute>
              }
            />
            <Route path={REPORTS_INFO.WOBURN_PTO.link} element={
                <ReportsPermissionRoute reportId={REPORTS_INFO.WOBURN_PTO.id}>
                  <WoburnPTOReport />
                </ReportsPermissionRoute>
              }
            />
            <Route path={REPORTS_INFO.WOBURN_MUNIS_PTO.link} element={
                <ReportsPermissionRoute reportId={REPORTS_INFO.WOBURN_MUNIS_PTO.id}>
                  <WoburnMunisPtoReport />
                </ReportsPermissionRoute>
              }
            />
            <Route path={REPORTS_INFO.WOBURN_MUNIS_OVERTIME.link} element={
                <ReportsPermissionRoute reportId={REPORTS_INFO.WOBURN_MUNIS_OVERTIME.id}>
                  <WoburnMunisOvertimeReport />
                </ReportsPermissionRoute>
              }
            />
						<Route path="firehouse/tickets" element={<Ticketing />} />
						<Route path="/firehouse/watch-party"	element={<WatchParty />} />
						<Route path="/firehouse/watch-party-work/:batch_id/:job_id" element={<ShiftWork />} />
						
            <Route path="/firehouse/incidents" element={<IncidentsPage />}>
              <Route index element={<Incidents />} />
              <Route path="overview" element={<Overview />} />
              <Route path="performance" element={<Performance />} />
              <Route path="map" element={<MapPage />} />
              <Route path="import-history" element={<ImportHistory />} />
            </Route>
            <Route path="/firehouse/pre-plans" element={<PrePlansAndInspections />} />
            <Route path="/firehouse/inspections" element={<PrePlansAndInspections />} />
            <Route path="/firehouse/neris-settings" element={<NerisSettingsPage />}>
              <Route index element={<NerisReportForm />} />
              <Route path='/firehouse/neris-settings/station-and-station-units' element={<StationAndUnitsForm />} />
              <Route path="groups-and-types" element={<NerisGroupAndTypes />} />
            </Route>
          </CustomRoutes>
        </Admin>
      </AuthProvider>
    </ThemeProvider>
  );
}
